module.exports = __webpack_public_path__ + "img/polakya.e53a5432.jpg";